import React from 'react';
import PropTypes from 'prop-types';

import { ExpansionPanelDetails as MuiExpansionPanelDetails } from '@material-ui/core';

const ExpansionPanelDetails = ({ children, ...rest }) => {
  return (
    <MuiExpansionPanelDetails
      {...rest}
    >
      { children }
    </MuiExpansionPanelDetails>
  )
}

ExpansionPanelDetails.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ExpansionPanelDetails;



// WEBPACK FOOTER //
// ./src/components/base/ExpansionPanelDetails/ExpansionPanelDetails.js